import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import { AppContext } from '../main';



const Collection = (props) => {
    const {
        handleEditItem
    } = props

    const {
        appState
    } = useContext(AppContext);

    const {
        games = {},
        editMode = false
    } = appState

    // console.log('ccccccgames', games?.games)
    if (!games?.games?.[0]) {
        return null
    }


    return (
        <div className="container">
            {editMode && <button className="d-label"
                style={{
                    display: 'flex',
                    // marginBottom: 200,
                    // position: 'absolute',
                    zIndex: 5,

                }}
                onClick={() => {
                    handleEditItem({
                        section: 'games',
                        config: games || {}
                    })
                }}
            >Edit</button>}
            <div className="row">
                <div className="col-12 text-center">
                    <div className="subtitle mb20">{games.title}</div>
                    <h2 className="wow fadeInUp">{games.subtitle}</h2>
                    <div className="spacer-20"></div>
                </div>

            </div>
            <div className="row g-4 sequence">
                {games?.[0] && games?.games.map((game) => (
                    <div key={game.id} className="col-lg-3 col-md-6 gallery-item">
                        <div className="de-item wow">
                            <div className="d-overlay">
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 30
                                }}>
                                    <div className="d-label" style={{
                                        // width: 130
                                    }}>{game.discount}</div>
                                    {/* {editMode && <button className="d-label"
                                                       style={{
                                                           display: 'flex',
                                                           // marginBottom: 200,
                                                           // position: 'absolute',
                                                           zIndex: 5,
               
                                                       }}
                                                       onClick={() => {
                                                           handleEditItem(game)
                                                       }}
                                                   >Edit</button>} */}
                                </div>

                                <div className="d-text">


                                    <h4>{game.title}</h4>
                                    <p className="d-price">Starting at <span className="price">{game.price}</span></p>
                                    <Link className="btn-main btn-fullwidth" to="/">{game.button}</Link>
                                </div>
                            </div>
                            <img src={game.image} className="img-fluid" alt={game.title} />
                        </div>
                    </div>
                ))}
            </div>
        </div >
    );
};

export default Collection;